import AloMovesAnimation from 'components_v2/Search/common/AloMovesAnimation'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

export const useGlobalLoader = () => {
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    const handler = (e) => setLoading(e?.detail?.loading)
    document.addEventListener('global-loader', handler)
    return () => document.removeEventListener('global-loader', handler)
  }, [])
  return loading
}

const Main = styled.div`
  height: 50vh;
  display: grid;
  align-items: center;
  justify-content: center;

  > div {
    margin: 0;
    height: fit-content;
    width: fit-content;
  }
`
const CommonLoader = () => {
  // Block body so scrollTo's return value isn't used as the effect cleanup.
  // Chrome 150+ returns a Promise from scrollTo, which React would otherwise
  // try to call as `destroy()` ("destroy is not a function").
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <Main>
      <AloMovesAnimation />
    </Main>
  )
}

export default CommonLoader
